import * as Styled from "./EventsPage.styles";

import {
  APIError,
  Chip,
  EventCard,
  PageContainer,
  ScrollToTopFAB,
} from "../../components";
import { Alert, Box, Button, Grid, IconButton, useTheme } from "@mui/material";
import { EventDetailsModal, NewEventCreatedModal, } from "../../modals";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import PWAModal from '../../modals/PWAModal/PWAModal'

import { CLEAR_NEW_EVENT_CREATED } from "../../store/actions/newEventActions";
import { Event } from "../../types/event";
import FilterEventsModal from "../../modals/FilterEventsModal/FilterEventsModal";
import KeyboardArrowDownOutlinedIcon from "@mui/icons-material/KeyboardArrowDownOutlined";
import KeyboardArrowUpOutlinedIcon from "@mui/icons-material/KeyboardArrowUpOutlined";
import { RootState } from "../../store/store";
import { createSelector } from "reselect";
import {
  FilterType,
  FormatType,
  OfficeLocation,
  clearSortAndFilterEvents,
  filterAndSortEvents,
  getAllEvents,
} from "../../store/actions/eventsActions";
import { getAllUserEvents } from "../../store/actions/userEventsActions";
import { getUserInfo } from "../../store/actions/userActions";
import { isCuid } from "cuid";
import { useAppDispatch } from "../../store/hooks";
import useHandleSortEvents from "../../hooks/useHandleSortEvents";
import { useSelector } from "react-redux";
import useHandleFilterSelections from "../../hooks/useHandleFilterSelections";
import NotInterestedOutlinedIcon from "@mui/icons-material/NotInterestedOutlined";
import PWABanner from "../../modals/PWAModal/PWABanner";
import PWAConfirmationModal from "../../modals/PWAModal/PWAConfirmationModal";

const EventsPage = () => {
  const theme = useTheme();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [alert, setAlert] = useState<any>(null);
  const [isAppDownloaded, setIsAppDownloaded] = useState(() => {
  const saved: any = localStorage.getItem("gather-pwa-reminder-dismissed");
  const initialValue = JSON.parse(saved);
  return initialValue || false;
});
  const [alertVisible, setAlertVisible] = useState(false);
  const isNavigating = useRef(false);

  useEffect(() => {
  localStorage.setItem("gather-pwa-reminder-dismissed", JSON.stringify(isAppDownloaded));
}, [isAppDownloaded]);

  useEffect(() => {
    if (location.state?.alert && !isNavigating.current) {
      setAlert(location.state.alert);
      setAlertVisible(true);
      isNavigating.current = true;
      setTimeout(() => {
        navigate(location.pathname, { replace: true, state: {} });

        isNavigating.current = false;
      }, 10000);
    } else {
      setAlert(null);
      setAlertVisible(false);
    }
  }, [location.state, navigate, location.pathname]);

  const queryParams = new URLSearchParams(location.search);
  const [searchParams] = useSearchParams();
  const eventIdFromQueryParam = queryParams.get("eventId");

  const [showAll, setShowAll] = useState(false);

  const handleClick = () => {
    setShowAll(!showAll);
  };


  const newEventState = useSelector((state: RootState) => state.newEvent);
  const userEmail = useSelector((state: RootState) => state.user.email);
  const userName = useSelector((state: RootState) => state.user.name);
  const allEvents = useSelector((state: RootState) => state.events.data);
  const allEventsSuccess = useSelector(
    (state: RootState) => state.events.success
  );
  const allEventsError = useSelector((state: RootState) => state.events.error);
  const selectUserSignedUpEvents = (state: RootState) =>
    state.userEvents.signedUp;
  const metrics = useSelector((state: RootState) => state.eventFeedbacks.data);

  const selectFutureUserSignedUpEvents = createSelector(
    [selectUserSignedUpEvents],
    (userEvents) =>
      userEvents.filter(
        (event) => event.endDateTime > Math.floor(Date.now() / 1000)
      )
  );

  const userSignedUpEvents = useSelector(selectFutureUserSignedUpEvents);
  const userEventsSuccess = useSelector(
    (state: RootState) => state.userEvents.success
  );
  const userEventsError = useSelector(
    (state: RootState) => state.userEvents.error
  );
  const eventsSortType = useSelector(
    (state: RootState) => state.events.sortType
  );
  const eventFilters = useSelector(
    (state: RootState) => state.events.eventFilters
  );

  let eventsFiltersObject;
  const displayUpcomingElements = useMemo(() => {
    return showAll ? userSignedUpEvents : userSignedUpEvents.slice(0, 3);
  }, [showAll, userSignedUpEvents]);

  const [eventDetailsId, setEventDetailsId] = useState("");
  const [showEventDetailsModal, setShowEventDetailsModal] = useState(false);
  const [showNewEventCreatedModal, setShowNewEventCreatedModal] =
    useState(false);
  const [showFilterEventsModal, setFilterEventsModal] = useState(false);
  const [showPWAModal, setShowPWAModal] = useState<boolean>(false);
  const [showPWABanner, setShowPWABanner] = useState<boolean>(false);
  const [showPWAReminder, setShowPWAReminder] = useState<boolean>(false);

  const { displayedEventsList, displayedFilterCount } = useHandleSortEvents(
    allEvents,
    eventsSortType,
    eventFilters
  );


  let { displayedFilterSelections } = useHandleFilterSelections(
    allEvents,
    eventsSortType,
    eventFilters
  );

  const isFilterArrayEmpty = displayedFilterSelections.length < 1

  const onDeleteFilterPill = (label: string, eventsFilterType?: FilterType) => {
    eventsFiltersObject = {
      format: eventsFilterType?.format as FormatType,
      office: eventsFilterType?.office,
      eventTags: eventsFilterType?.eventTags,
    };
    if (eventsFilterType?.format.length) {
      if (eventsFilterType?.format === label) {
        displayedFilterSelections = displayedFilterSelections.filter(
          (eventTypeFilter) => label === eventTypeFilter
        );
        eventsFiltersObject.format = FormatType.ALL;
      }
    }
    if (eventsFilterType?.office.length) {
      if (eventsFilterType?.office === label) {
        displayedFilterSelections = displayedFilterSelections.filter(
          (eventTypeFilter) => label === eventTypeFilter
        );
        eventsFiltersObject.office = OfficeLocation.NEW_ENGLAND;
      }
    }

    if (eventsFilterType?.eventTags.length) {
      let eventTagFilters = eventsFilterType?.eventTags;
      if (!eventTagFilters.includes("All")) {
        if (eventTagFilters.includes(label)) {
          eventTagFilters = eventTagFilters.filter(
            (eventTag) => label !== eventTag
          );
          eventsFiltersObject.eventTags = eventTagFilters;
        }
      }
    }
    dispatch(
      filterAndSortEvents({
        filters: {
          format: eventsFiltersObject.format as FormatType,
          eventTags: eventsFiltersObject.eventTags!,
          office: eventsFiltersObject.office as OfficeLocation,
        },
      })
    );
  };

  useEffect(() => {
    if (eventIdFromQueryParam && isCuid(eventIdFromQueryParam)) {
      setEventDetailsId(eventIdFromQueryParam);
      setShowEventDetailsModal(true);
    }
  }, [eventIdFromQueryParam]);

  

  useEffect(() => {
    if (!searchParams.has("eventId")) {
      setShowEventDetailsModal(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  useEffect(() => {
    setShowNewEventCreatedModal(newEventState.eventCreated);
  }, [newEventState.eventCreated]);

  useEffect(() => {
    setShowPWAModal(true);
  }, [])


  const handleCloseEventDetailsModal = useCallback(() => {
    navigate("/events", { replace: true });
    setShowEventDetailsModal(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleCloseNewEventModal = useCallback(() => {
    dispatch({ type: CLEAR_NEW_EVENT_CREATED });
    setShowNewEventCreatedModal(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleCloseFilterEventsModal = useCallback(() => {
    setFilterEventsModal(false);
  }, []);

  const handleClosePWAModal = useCallback(() => {
    setShowPWAModal(false);
  }, []);

  return (
    <PageContainer>
      <NewEventCreatedModal
        open={showNewEventCreatedModal}
        onClose={handleCloseNewEventModal}
      />
      <EventDetailsModal
        eventId={eventDetailsId}
        open={showEventDetailsModal}
        onClose={handleCloseEventDetailsModal}
      />
      <FilterEventsModal
        filterPills={displayedFilterSelections}
        open={showFilterEventsModal}
        onClose={handleCloseFilterEventsModal}
      />
     {!isAppDownloaded &&  <PWAModal 
        onClose={handleClosePWAModal}
        openModal={showPWAModal}
        onDownloaded={() => {
          setShowPWAModal(false)
          setShowPWABanner(false)
          setIsAppDownloaded(true)
        }}
        onDelayDownload={() => {
          setShowPWAModal(false)
          setShowPWABanner(true)
        }}
      />}
      <PWAConfirmationModal openModal={showPWAReminder} onDownloaded={() => {setShowPWABanner(false); setShowPWAReminder(false); ; setIsAppDownloaded(true)}} onDelayDownload={() => {setShowPWAReminder(false); setShowPWABanner(true)}}></PWAConfirmationModal>
      <ScrollToTopFAB />
      {showPWABanner && <PWABanner onClose={() => {setShowPWAReminder(true)}} openModal={() => {setShowPWAModal(true)}}></PWABanner>}
      <Styled.PaddedContainer>
        {alertVisible && (
          <Alert
            severity={alert.severity}
            sx={{ marginBottom: theme.spacing(2) }}
            onClose={() => {
              setAlert(null);
              setAlertVisible(false);
            }}
          >
            {alert.message}
          </Alert>
        )}
        
        <Styled.HeaderStack direction="row" width="100%">
          <Styled.HeaderText variant="h1">Hello, {userName} </Styled.HeaderText>
        </Styled.HeaderStack>
        {userEventsSuccess ? (
          <Styled.SubtitleContainer>
            <Styled.SubtitleStackContainer
              direction={{ mobile: "column", tablet: "row", desktop: "row" }}
              spacing={2}
            >
              <Styled.SubtitleTitle variant="h3">
                {displayUpcomingElements.length > 0
                  ? `My Upcoming Events (${displayUpcomingElements.length})`
                  : "You are not signed up for any upcoming events"}
              </Styled.SubtitleTitle>
              <Styled.SubtitleActionContainer>
                <Styled.SubtitleActionText
                  variant="modalSubtitle"
                  onClick={() => {
                    navigate("/events/past");
                  }}
                >
                  View my past events
                </Styled.SubtitleActionText>
              </Styled.SubtitleActionContainer>
            </Styled.SubtitleStackContainer>
            {displayUpcomingElements.length > 0 && (
              <Styled.SubtitleText variant="body2">
                Here are all of the upcoming events that you’ve signed up to attend. Select an event to view additional details and to adjust your RSVP response.
              </Styled.SubtitleText>
            )}
          </Styled.SubtitleContainer>
        ) : (
          <Styled.SubtitleContainerSkeleton />
        )}
        {/* UPCOMING EVENTS GRID */}
        {userEventsError ? (
          <APIError
            onClick={() => {
              dispatch(getUserInfo());
              dispatch(getAllUserEvents(userEmail));
            }}
          />
        ) : (
          <Styled.ScrollContainer>
            <Grid
              container
              spacing={3}
              columns={{
                mobile: 4,
                tablet: 8,
                desktop: 12,
              }}
            >
              {!userEventsSuccess ? (
                Array.from({ length: 3 }, (_, index) => (
                  <Grid key={index} item mobile={4} tablet={4} desktop={4}>
                    <Styled.SkeletonCardContainer>
                      <Styled.SkeletonCardImage
                        variant="rectangular"
                        animation="wave"
                      />
                      <Styled.SkeletonCardText
                        variant="text"
                        animation="wave"
                      />
                      <Styled.SkeletonCardDescription
                        variant="rectangular"
                        animation="wave"
                      />
                    </Styled.SkeletonCardContainer>
                  </Grid>
                ))
              ) : (
                <>
                  {displayUpcomingElements.map((event: Event) => (
                    <Grid
                      key={event.eventId}
                      item
                      mobile={4}
                      tablet={4}
                      desktop={4}
                    >
                      <EventCard
                        {...event}
                        attendees={metrics?.countAttended}
                        onClick={() => {
                          navigate(
                            `${location.pathname}?eventId=${event.eventId}`,
                            { replace: true }
                          );
                          setEventDetailsId(event.eventId);
                          setShowEventDetailsModal(true);
                        }}
                      />
                    </Grid>
                  ))}
                  {userSignedUpEvents.length > 3 && (
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        width: "100%",
                        marginTop: theme.spacing(1),
                      }}
                    >
                      <IconButton onClick={handleClick}>
                        {showAll ? (
                          <KeyboardArrowUpOutlinedIcon color="primary" />
                        ) : (
                          <KeyboardArrowDownOutlinedIcon color="primary" />
                        )}
                      </IconButton>
                    </Box>
                  )}
                </>
              )}
            </Grid>
          </Styled.ScrollContainer>
        )}
        {/* ALL EVENTS GRID */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginTop: displayUpcomingElements.length < 3 ? theme.spacing(2) : 0,
            marginBottom: theme.spacing(2),
          }}
        >
          <Styled.AllEventsText
            variant="h2"
            style={{
              marginTop:
                displayUpcomingElements.length < 3 ? theme.spacing(2) : 0,
            }}
          >
            {isFilterArrayEmpty ? `All Events` : `Filtered Events (${displayedFilterCount})`}
          </Styled.AllEventsText>
          <Styled.SortAndFilterTextContainer>
            <Styled.SubtitleActionText
              variant="modalSubtitle"
              onClick={() => setFilterEventsModal(true)}
            >
              <Box display="flex" alignItems="center">
                <Styled.SortFilterIcon />
                {displayedFilterCount
                  ? `Sort & Filter (${displayedFilterCount})`
                  : "Sort & Filter"}
              </Box>
            </Styled.SubtitleActionText>
          </Styled.SortAndFilterTextContainer>
        </Box>
        {isFilterArrayEmpty && <Box sx={{ height: '48px' }}></Box>}
        <Styled.FilterPillClearAllTextContainer>
          {!isFilterArrayEmpty && <Box>
            {displayedFilterSelections.map((item) => {
              return (
                <>
                  <Chip
                    key={item}
                    label={item}
                    onDelete={() => onDeleteFilterPill(item, eventFilters)}
                  />
                </>
              );
            })}
          </Box>
          }
          {displayedFilterSelections.length > 0 && (
            <Box sx={{
              display: "flex",
              flexShrink: 1,
              width: "30%",
              justifyContent: "flex-end"
            }}>
              <Styled.ClearAllTextContainer>
                <Styled.ClearAllButton
                  sx={{ padding: "0px" }}
                  variant="modalSubtitle"
                  onClick={() => {
                    dispatch(clearSortAndFilterEvents());
                  }}
                >
                  <NotInterestedOutlinedIcon sx={{ width: '20px' }} />
                  <Box sx={{ padding: "5px" }}>
                    Clear All
                  </Box>
                </Styled.ClearAllButton>
              </Styled.ClearAllTextContainer>
            </Box>
          )}
        </Styled.FilterPillClearAllTextContainer>
        {allEventsError ? (
          <APIError
            onClick={() => {
              dispatch(getUserInfo());
              dispatch(getAllEvents());
            }}
          />
        ) : (
          <Styled.ScrollContainer>
            <Grid
              container
              spacing={3}
              columns={{
                mobile: 4,
                tablet: 8,
                desktop: 12,
              }}
            >
              {!allEventsSuccess ? (
                Array.from({ length: 3 }, (_, index) => (
                  <Grid key={index} item mobile={4} tablet={4} desktop={4}>
                    <Styled.SkeletonCardContainer>
                      <Styled.SkeletonCardImage
                        variant="rectangular"
                        animation="wave"
                      />
                      <Styled.SkeletonCardText
                        variant="text"
                        animation="wave"
                      />
                      <Styled.SkeletonCardDescription
                        variant="rectangular"
                        animation="wave"
                      />
                    </Styled.SkeletonCardContainer>
                  </Grid>
                ))
              ) : allEvents.length === 0 ? (
                <Styled.NoUpcomingEventsContainer>
                  <Box>
                    <Styled.CalendarIcon />
                    <Styled.NoUpcomingEventsText variant="h1">
                      No Upcoming Events
                    </Styled.NoUpcomingEventsText>
                    <Styled.NoUpcomingEventsText>
                      There are no upcoming events scheduled. Check back later!
                    </Styled.NoUpcomingEventsText>
                  </Box>
                </Styled.NoUpcomingEventsContainer>
              ) : displayedEventsList.length === 0 ? (
                <Styled.NoUpcomingEventsContainer>
                  <Box>
                    <Styled.NoUpcomingEventsText variant="h1">
                      No Events Were Found
                    </Styled.NoUpcomingEventsText>
                    <Styled.NoUpcomingEventsText>
                      Your current filter selection yielded no results.
                    </Styled.NoUpcomingEventsText>
                    <Button
                      variant="contained"
                      onClick={() => {
                        setFilterEventsModal(true);
                      }}
                    >
                      Refine Your Filters
                    </Button>
                  </Box>
                </Styled.NoUpcomingEventsContainer>
              ) : (
                displayedEventsList.map((event: Event) => (
                  <Grid
                    key={event.eventId}
                    item
                    mobile={4}
                    tablet={4}
                    desktop={4}
                  >
                    <EventCard
                      {...event}
                      onClick={() => {
                        navigate(
                          `${location.pathname}?eventId=${event.eventId}`,
                          { replace: true }
                        );
                      }}
                    />
                  </Grid>
                ))
              )}
            </Grid>
          </Styled.ScrollContainer>
        )}
      </Styled.PaddedContainer>
    </PageContainer>
  );
};

export default EventsPage;
